import React from 'react';
import { useEffect, useState, useRef, useCallback } from "react";
import {Col, Row} from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { APILA } from "../../../../../config/apila";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { PulseLoader} from "react-spinners";
import { APIMS } from '../../../../../config/apims';

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
@keyframes shimmer {
  0% { background-position: -468px 0; }
  100% { background-position: 468px 0; }
}
.shimmer {
  animation-duration: 1.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: shimmer;
  background: #f6f7f8;
  background: linear-gradient(
    to right,
    #ddeaffff 8%,
    #f4f8ffff 18%,
    #ddeaffff 33%
  );
  background-size: 800px 104px;
}
.shimmer-select {
  height: 35px;
  border-radius: 4px;
}
.shimmer-row {
  height: 38px;
}

  /* ✅ ROW HOVER: input border ikut berwarna */
  .ysb-score-input{
    transition: border-color .12s ease, box-shadow .12s ease;
  }
  .ysb-row-hover:hover .ysb-score-input{
    border-color:#c0d2f1 !important;
  }
  .ysb-row-hover:hover .ysb-score-input:not(.ysb-input-disabled){
    box-shadow: 0 0 0 2px rgba(0, 68, 255, 0.18);
  } 
  .ysb-row-hover:hover .ysb-score-input.ysb-input-disabled{
    border-color:#cbd5e1 !important;
    box-shadow:none;
  }
`;

export default function PenilaianKepsek() {
  document.title = "Penilaian";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword, setKeyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const storageBranch = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  /* DATA STATES */
  const [getDataSemester, setGetDataSemester] = useState(null);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getData, setGetData] = useState([]);
  const storageSchoolId = localStorage.getItem('ysb_school_id');

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  

  const [loading, setLoading] = useState(true);        
  const [isFetching, setIsFetching] = useState(false); 

  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  /* ====================================== PERMISSION ====================================== */
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  useEffect(() => {
    const storageLevel = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (
      storageLevel === "developer" ||
      storageLevel === "superadmin"
    ) {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
    } else {
      const found = storageItems.find(
        (item) => item.menu?.url === location.pathname
      );
      if (!found) navigate("/dashboard");
      else setPermission(found);
    }
  }, [location.pathname, navigate]);

  /* ====================================== FORM STATES ====================================== */

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: ""
  });

 const isFilterComplete =
  isFilterDirty &&
  !!form2.ysb_semester_id &&
  !!form2.ysb_dimensi_id;



  /* API HEADERS */
  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);


  /* =============================================================================================== */
  /* ===============================  FETCH INIT (SEMESTER, DIMENSI)  ============= */
  /* =============================================================================================== */

  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes, dimensiRes] = await Promise.all([
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      /* ------------------- SET SEMESTER ------------------- */
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1);

        setGetDataSemester(active || null);
        setGetDataSemesterMap(semesters);

        if (active) {
          setNamaTA(active.name_year);
          setNamaSmstr(active.semester);

          setForm2((prev) => ({
            ...prev,
            ysb_semester_id: active.id,
          }));
        }
      }

      /* ------------------- SET DIMENSI ------------------- */
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter(
          (d) => d.status === 1
        );
        setGetDataDimensi(dims);

        if (dims.length > 0) {
          setForm2((prev) => ({
            ...prev,
            ysb_dimensi_id: dims[0].id,
          }));
        }
      }

    } catch (err) {
      swal({
        title: "Failed",
        text:
          err?.response?.data?.message ||
          err.message ||
          "Error",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [ascending, descending, keyword, limit, page, storageBranch, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  /* =============================================================================================== */
  /* ===============================  FETCH DATA CONFIG =========================================== */
  /* =============================================================================================== */

  const GetResponseData = async () => {
    if (isFetching) return; 
    setIsFetching(true);
    try {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_dimensi_id
      )
        return;

      const res = await APILA.get("/api/element-recap-head-values", {
        params: {

          ysb_semester_id: form2?.ysb_semester_id,
          level: storageLevel,
          branch: storageBranch,
          ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: storageSchoolId
        },
        ...fetchParams,
      });
 
      if (res?.status === 200) {
        setGetData(res.data.data);
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };


     /* ======================= 🔥 AUTO SELECT TAB ======================= */
    useEffect(() => {
      if (
        getData.length > 0 &&
        getData[0]?.data_element?.length > 0 &&
        !selectedTab
      ) {
        setSelectedTab(getData[0].data_element[0].name_element);
      }
    }, [getData, selectedTab]);
  
    // FIRST LOAD
    useEffect(() => {
      if (
        isFirstLoad &&
        form2.ysb_semester_id &&
        form2.ysb_dimensi_id
      ) {
          setIsFetching(true);                
          GetResponseData().finally(() => {
            setIsFetching(false);             
          });
    
          setHasSearched(true);  
          setIsFirstLoad(false); 
          setIsFilterDirty(false); 
        }
    }, [
          isFirstLoad,
          form2.ysb_semester_id,
          form2.ysb_dimensi_id
        ]
    );
    

  /* ====================================== FILTER CHANGE ====================================== */

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);   
      setHasSearched(false);
    }

  };


    /* ======================= RESET TAB WHEN FILTER CHANGE ======================= */
    useEffect(() => {
      setSelectedTab(null);
    }, [
      form2.ysb_semester_id,
      form2.ysb_dimensi_id,
    ]);

  /* =============================================================================================== */
  /* ===============================  BUTTON CARI VALIDATION ====================================== */
  /* =============================================================================================== */

  const handleCari = async () => {
    if (!isFilterComplete) return;

    setSelectedTab(null);

    setGetData([]);
    setHasSearched(false);

    setIsFetching(true);

    try {
      await GetResponseData(); 

      setHasSearched(true);
      setIsFilterDirty(false);
    } finally {
      setIsFetching(false);
    }
  };

// Simpan nilai awal saat user mulai fokus ke cell
const initialNilaiRef = useRef({});

const normalizeNilai = (v) => {
  if (v === "" || v === null || typeof v === "undefined") return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
};

const getCellKey = (elementId, rekap) => `${elementId}_${rekap?.ysb_sub_element_id}`;

const handleFocusNilai = (elementId, rekap) => {
  const key = getCellKey(elementId, rekap);
  initialNilaiRef.current[key] = normalizeNilai(rekap?.ysb_sub_element_value);
};

const isValidNilaiInteger = (v) => {
  if (v === "" || v === null || typeof v === "undefined") return true; // boleh kosong
  // hanya boleh 1 digit: 1-4 (tanpa desimal)
  return /^[1-4]$/.test(String(v));
};


/* =========================
     INPUT NILAI
  ========================== */
  const handleChangeNilaiLocal = (e, elementId, rekap) => {
    const value = e.target.value;

    if (!isValidNilaiInteger(value)) return;

    setGetData(prev => {
      const copy = JSON.parse(JSON.stringify(prev));
      const el = copy[0].data_element.find(x => x.id === elementId);
      const row = el.rekapan.find(r => r.ysb_sub_element_id === rekap.ysb_sub_element_id);
      row.ysb_sub_element_value = value === "" ? null : value; 
      return copy;
    });
  };


  
    const saveNilaiDB = async (rekap, elementId, value) => {
    
    const recapId = rekap.ysb_element_recap_head_id;

    const payload = {
      ysb_sub_element_id: rekap.ysb_sub_element_id,
      ysb_sub_element_value: value,
      ysb_branch_id: storageBranch,
      ysb_school_id: storageSchoolId,
      ysb_dimensi_id: form2.ysb_dimensi_id,
      ysb_semester_id: form2.ysb_semester_id,
      ysb_element_id: elementId,
      user_id: output_id_user
    };

    try {
      if (recapId === "default") {
        await APILA.put("/api/element-recap-head-values/default", payload, fetchParams);
        await GetResponseData();
        ToastSuccess.fire({ icon: "success", title: "Nilai berhasil disimpan" });
        return;
      }

      await APILA.put(`/api/element-recap-head-values/${recapId}`, payload, fetchParams);
      ToastSuccess.fire({ icon: "success", title: "Nilai berhasil diupdate" });
    } catch (err) {
      ToastError.fire({ icon: "error", title: "Gagal menyimpan nilai" });
    }
  };

  const handleBlurNilai = (e, elementId, rekap) => {
    const key = getCellKey(elementId, rekap);

    const rawAfter = e.target.value;

    if (!isValidNilaiInteger(rawAfter)) {
      const before = initialNilaiRef.current[key];

      setGetData(prev => {
        const copy = JSON.parse(JSON.stringify(prev));
        const el = copy[0].data_element.find(x => x.id === elementId);
        const row = el.rekapan.find(r => r.ysb_sub_element_id === rekap.ysb_sub_element_id);
        row.ysb_sub_element_value = before === null ? null : String(before);
        return copy;
      });

      ToastError.fire({ icon: "error", title: "Nilai harus bilangan bulat 1 - 4 (tanpa desimal)" });
      return;
    }

    const before = initialNilaiRef.current[key];
    const after = normalizeNilai(e.target.value);

    
    if (after !== null && (after < 1 || after > 4)) return;

   
    if (typeof before === "undefined") return;

    if (before === after) return;

    saveNilaiDB(rekap, elementId, after);

    initialNilaiRef.current[key] = after;
  };



  /* =========================
     RENDER
  ========================== */
  return (
    <>
    <style>{shimmerStyle}</style>

    <div className="body" >
        {/* <div className="body-header d-flex">
              {isTabletOrMobile ? 
                <>
                  <div className="title-page">
                    <h6><FontAwesomeIcon icon={faListUl}/> Penilaian</h6>
                  </div> 
                </>
                : 
                <>
                  <div className="title-page">
                    <h5><FontAwesomeIcon icon={faListUl}/> Penilaian </h5>
                  </div>
                </>
              }   
        </div>  */}

      <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faIdCard} />
                  </span>
                <h4 className="page-title-text"> Penilaian</h4>
              </div>
            </div>

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-head">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Penilaian
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faIdCard} />
                </span>
                <h4 className="page-title-text"> Penilaian</h4>
              </div>
            </div>

            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-head">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Penilaian
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>
    
        {/* <div className="body-content-menu">
            <div className="breadcrumb-header " style={{fontSize:"13px" }}>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"> <Link style={{textDecoration:"none"}} to="/dashboards-head">Dashboard</Link>  </li>
                        <li className="breadcrumb-item iniaktif" > <span className='ml-2'> Penilaian</span> </li>
                    </ol>
                </nav>
            </div>
        </div> */}
          
        <div className="body-content">

          
            {/* FILTER */}
            {isTabletOrMobile ? 
              <>
              <div className="title-page">
                  <Row style={{marginTop: "10px", padding:"0 12px"}}>
                    <select className="mr-2" aria-label="Default select example" name="ysb_semester_id" value={form2?.ysb_semester_id}  onChange={handleChange}
                    style={{
                      border: "1px solid #d9defa",
                      borderRadius: "12px",
                      fontSize: "14px",
                      padding: "10px 12px",
                      background: "#fff",
                    }}>
                              
                      <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                      {getDataSemesterMap.map((user,index) => (
                        <option key={index} value={user?.id} style={{textAlign:""}}>{user?.name_year} (Semester {user?.semester})</option>
                      ))}  
                    </select>
                  </Row>
              
                  <Row style={{marginTop: "10px", padding:"0 12px"}}>
                    <select className="mr-2" aria-label="Default select example" name="ysb_dimensi_id" value={form2?.ysb_dimensi_id}  onChange={handleChange}  
                      style={{
                        border: "1px solid #d9defa",
                        borderRadius: "12px",
                        fontSize: "14px",
                        padding: "10px 12px",
                        background: "#fff",
                      }}
                    >
                              
                    <option value="" hidden>Pilih Dimensi</option>
                      {getDataDimensi.map((user,index) => (
                        <option value={user?.id} style={{textAlign:""}}>{user?.name_dimensi}</option>
                      ))} 
                    </select>
                  </Row>
    
                                          
                  <Row style={{marginTop: "12px", padding:"0 12px"}}>
                    {/* <button onClick={handleCari} className=" btn " style={{fontSize: '13px', padding:'5px 10px', marginTop: '-2px', borderRadius:"0", backgroundColor:"#eca91aff", color: "#fff"}}> Cari</button> */}
                    <button
                      onClick={handleCari}
                      disabled={!isFilterComplete}
                      title={!isFilterComplete ? "Lengkapi dan ubah filter terlebih dahulu" : ""}
                      className="btn"
                      style={{
                        fontSize: "13px",
                         padding: "10px 16px",
                        borderRadius: "12px",
                        backgroundColor: isFilterComplete ? "#eca91aff" : "#b6b6b6ff",
                        color: "#fff",
                        cursor: isFilterComplete ? "pointer" : "not-allowed",
                        opacity: isFilterComplete ? 1 : 0.6
                      }}
                    >
                      Cari
                    </button>
                  </Row>
                </div>
              </>
              :
              <>
                <div className="mb-3 d-flex">
                  {loading ? (
                      <>
                        <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                        <div className="shimmer shimmer-select mr-2" style={{width:60, borderRadius: "12px"}} />
                      </>
                    ) : (
                      <div className="mb-3 ">
                      <div className="d-flex">
                       
                        <select className="mr-2" aria-label="Default select example" name="ysb_semester_id" value={form2?.ysb_semester_id} onChange={handleChange} disabled={loading}  
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                          }}
                        >
                            <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                            {getDataSemesterMap.map((user,index) => (
                              <option key={index} value={user?.id} style={{textAlign:""}}>{user?.name_year} (Semester {user?.semester})</option>
                            ))} 
                        </select>
                      
                        <select className="mr-2" aria-label="Default select example" onChange={handleChange} value={form2?.ysb_dimensi_id}  name="ysb_dimensi_id" 
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                          }}
                        >
                          <option value="" hidden>Pilih Dimensi</option>
                          {getDataDimensi.map((user,index) => (
                            <option value={user?.id} style={{textAlign:""}}>{user?.name_dimensi}</option>
                          ))}      
                        </select>

                        <button
                          onClick={handleCari}
                          disabled={!isFilterComplete}
                          title={!isFilterComplete ? "Lengkapi dan ubah filter terlebih dahulu" : ""}
                          className="btn"
                          style={{
                            fontSize: "13px",
                            padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: isFilterComplete ? "#eca91aff" : "#b6b6b6ff",
                            color: "#fff",
                            cursor: isFilterComplete ? "pointer" : "not-allowed",
                            opacity: isFilterComplete ? 1 : 0.6
                          }}
                        >
                          Cari
                        </button>
                  </div>
                </div>
                  )}
                </div>
                
              </>
            }
    
            {isFetching && (
              <div className="text-center" style={{ padding: "10px 0" }}>
                <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
              </div>
          )}

          {hasSearched && !isFetching && getData.length > 0 && (
            <Tabs  activeKey={selectedTab}
            onSelect={(k) => setSelectedTab(k)}
            className=" nav-tabs"> 
                
            {(getData?.[0]?.data_element || [] ).map((element, eIdx) => (
            <Tab key={element?.id || eIdx} eventKey={element?.name_element} title={element?.name_element} className="nav-item">
              <div className="text-center" style={{ marginTop: "10px", marginBottom: "20px", backgroundColor: "#9fd5ffff", padding: "5px 0px" }}>
                <h5 className="mt-2 mb-2">{element?.description}</h5>
              </div>

              {/* TABLE */}
              <Col xl='12' sm='12'>
                <div className="mt-3">
                  <div className="body-table">
                    <div className="">
                    <table className="table table-laporan-adab  table-hover table-bordered " id="basic-datatable">
                        <thead>
                          <tr>
                          
                              <th className="border border-gray-300 p-3 bg-gray-100 text-center">Nama Kegiatan  </th>
                              <th className="border border-gray-300 p-3 bg-gray-100 text-center">Rata-Rata Penilaian Guru</th>
                              <th className="border border-gray-300 p-3 bg-gray-100 text-center">Nilai</th>
                          </tr>
                        </thead>
                        <tbody>
                          {element?.rekapan?.map((rekap, idx) => (
                            <tr className="ysb-row-hover">
                              <th style={{border: "1px solid #e0e0e0ff", lineHeight: "2", fontSize: "14px", fontWeight: "400"}} key={rekap?.ysb_sub_element_id || idx}>{rekap?.ysb_sub_element_name || rekap?.description}</th>
                              {/* <td>{rekap.ysb_sub_element_value_teacher_average} </td> */}
                              <td
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                  color:
                                    rekap?.ysb_sub_element_status === 0
                                      ? "#dc3545"
                                      : "#000"
                                }}
                              >
                                {rekap?.ysb_sub_element_value_teacher_average}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "60px",
                                      height: "38px",
                                      margin: "0 auto"
                                    }}
                                  >
                                    <input
                                      type="text"
                                      className="ysb-score-input form-control text-center"
                                      value={rekap?.ysb_sub_element_value ?? ""}
                                      disabled={rekap?.ysb_sub_element_status === 0}
                                      onFocus={() => {
                                        if (rekap?.ysb_sub_element_status === 0) return;
                                        handleFocusNilai(element.id, rekap);
                                      }}
                                      onChange={(e) => {
                                        if (rekap?.ysb_sub_element_status === 0) return;
                                        handleChangeNilaiLocal(e, element.id, rekap);
                                      }}
                                      onBlur={(e) => {
                                        if (rekap?.ysb_sub_element_status === 0) return;
                                        handleBlurNilai(e, element.id, rekap);
                                      }}
                                      onKeyDown={(e) => {
                                        // blok . dan , biar tidak bisa desimal
                                        if (e.key === "." || e.key === ",") e.preventDefault();

                                        // opsional: blok karakter lain yang sering masuk di input angka
                                        if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                                      }}

                                      style={{
                                        height: "35px",
                                        backgroundColor:
                                          rekap?.ysb_sub_element_status === 0 ? "#eeeeee" : "transparent",
                                        cursor:
                                          rekap?.ysb_sub_element_status === 0 ? "not-allowed" : "text",
                                       
                                      }}
                                    />

                                    {/* 🔒 ICON GEMBOK TENGAH */}
                                    {rekap?.ysb_sub_element_status === 0 && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          pointerEvents: "none"
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faLock}
                                          style={{ color: "#9e9e9e", fontSize: "14px" }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </td>
  
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Col>
            </Tab>
          ))}
        
        </Tabs>
      )}
          
      </div>
    </div>
    </>
     

  );
}
